/**
 * Sorting plugin for the grid
 * @class
 */
const Sort = function (grid) {
	const dataModel = grid.behavior.dataModel;

	this.grid = grid;
	this.data = dataModel.dataSource.data;

	// Listen for column sort request
	grid.addEventListener('fin-column-sort', _.bind(this.toggleSort, this));
	grid.addEventListener('fin-cell-enter', _.bind(this.cellEnter, this));
	grid.addEventListener('fin-cell-exit', _.bind(this.cellExit, this));

	// Cannot trust this event
	// grid.addEventListener('fin-canvas-mouseout', _.bind( this.canvasMouseOut, this ) );
	grid.div.addEventListener(
		'mouseleave',
		(this.onmouseleave = _.bind(this.canvasMouseOut, this)),
	);

	// Build a in-memory sorting Index
	this.index = dataModel.sortIndex = new Array(this.data.length);
	this.unsort();

	// Custom methods
	dataModel.getRowIndex = _.bind(this.getRowIndex, this);
	dataModel.getValueByField = _.bind(this.getValueByField, this);

	// Backup methods before overriding
	this.oldGetValue = dataModel.getValue;
	this.oldSaveValue = dataModel.setValue;

	// Override methods
	const self = this;
	dataModel.getValue = function (x, y) {
		const row = self.data[self.index[y]];
		if (!row) return null;
		return row[this.dataSource.schema[x].name];
	};
	dataModel.setValue = function (x, y, value) {
		this.getRow(self.index[y])[this.schema[x].name] = value;
	};
};

Sort.prototype = {
	$$CLASS_NAME: 'sort',
	constructor: Sort,

	/** @type {number} */
	columnIndex: null,

	/** @type {number} */
	columnHoverIndex: null,

	/**
	 * @method
	 * @param {mixed} a Value a
	 * @param {mixed} b Value b
	 */
	ascendingComparator: function (a, b) {
		if (b === null) b = '';
		if (a === null) a = '';
		if (Array.isArray(a)) {
			a = a.join().toLowerCase();
		} else if (typeof a === 'string') {
			a = a.toLowerCase();
		}
		if (Array.isArray(b)) {
			b = b.join().toLowerCase();
		} else if (typeof b === 'string') {
			b = b.toLowerCase();
		}

		if (b === void 0 || a > b) {
			return 1;
		}
		if (a === void 0 || a < b) {
			return -1;
		}
		// a must be equal to b
		return 0;
	},

	/**
	 * @method
	 * @param {event} event `fin-canvas-mouseout` event
	 */
	canvasMouseOut(event) {
		const grid = this.grid;
		const behavior = grid.behavior;

		let column, colProps;

		const lastHover =
			this.columnHoverIndex != null
				? this.columnHoverIndex
				: this.lastColumnHoverIndex;

		if (this.columnIndex === lastHover) {
			column = behavior.getColumn(this.columnIndex);
			colProps = column && column.properties;

			if (!colProps || colProps.sortable === false) return;

			colProps.columnRightIcon =
				this.order === 'asc' ? 'up-rectangle' : 'down-rectangle';
		} else {
			column = behavior.getColumn(lastHover);
			colProps = column && column.properties;

			if (!colProps || colProps.sortable === false) return;

			colProps.columnRightIcon = '';
		}
		this.columnHoverIndex = null;
		this.grid.repaint();
	},

	/**
	 * @method
	 * @param {event} event `fin-cell-enter` event
	 */
	cellEnter(event) {
		const grid = this.grid;
		const point = event.detail.dataCell;

		// If a header cell
		if (event.detail.isHeaderCell) {
			let colProps = grid.behavior.getColumn(point.x).properties;

			if (!colProps || colProps.sortable === false) return;

			if (point.x === this.columnIndex) {
				if (this.order === 'desc') {
					colProps.columnRightIcon = 'up-rectangle';
				} else if (this.order !== 'asc') {
					colProps.columnRightIcon = 'down-rectangle';
				}
			} else {
				colProps.columnRightIcon = 'down-rectangle';
			}
			this.lastColumnHoverIndex = this.columnHoverIndex = point.x;
		}
	},

	/**
	 * @method
	 * @param {event} event `fin-cell-exit` event
	 */
	cellExit(event) {
		const grid = this.grid;
		const behavior = grid.behavior;

		if (this.columnHoverIndex !== null) {
			let colProps;

			if (this.columnIndex === this.columnHoverIndex) {
				colProps = behavior.getColumn(this.columnIndex).properties;

				if (!colProps || colProps.sortable === false) return;

				colProps.columnRightIcon =
					this.order === 'asc' ? 'up-rectangle' : 'down-rectangle';
			} else {
				colProps = behavior.getColumn(this.columnHoverIndex).properties;

				if (!colProps || colProps.sortable === false) return;

				colProps.columnRightIcon = '';
			}
			this.columnHoverIndex = null;
		}
	},

	/**
	 * @method
	 * @param {mixed} a Value a
	 * @param {mixed} b Value b
	 */
	descendingComparator(a, b) {
		if (b === null) b = '';
		if (a === null) a = '';
		if (Array.isArray(a)) {
			a = a.join().toLowerCase();
		} else if (typeof a === 'string') {
			a = a.toLowerCase();
		}
		if (Array.isArray(b)) {
			b = b.join().toLowerCase();
		} else if (typeof b === 'string') {
			b = b.toLowerCase();
		}
		if (a === void 0 || a < b) {
			return 1;
		}
		if (b === void 0 || a > b) {
			return -1;
		}
		// a must be equal to b
		return 0;
	},

	/**
	 * @method
	 * @param {string} field Field name
	 * @param {mixed} value Value
	 * @return {number} Row index
	 */
	getRowIndex(field, value) {
		for (let i = 0, data = this.data, c = data.length; i < c; i++) {
			if (data[i][field] === value) {
				return this.index.indexOf(i);
			}
		}
	},

	/**
	 * @method
	 * @param {number} y Row index
	 * @param {string} field Field name
	 * @return {mixed} Value
	 */
	getValueByField(y, field) {
		const row = this.data[this.index[y]];
		if (!row) return null;
		return row[field];
	},

	/**
	 * @method
	 * @param {number} column Column index
	 * @param {string} order Order ("asc"/"desc")
	 */
	setSort(column, order) {
		if (
			column == null ||
			order == null ||
			(this.columnIndex === column && this.order === order)
		) {
			return;
		}

		const grid = this.grid;
		const behavior = grid.behavior;

		// Remove any privious icon
		if (this.columnIndex !== null) {
			behavior.getColumn(this.columnIndex).properties.columnRightIcon = '';
		}

		let colProps = behavior.getColumn(column).properties;
		if (!colProps || colProps.sortable === false) return;

		// Set new icon
		colProps.columnRightIcon =
			order === 'desc' ? 'down-rectangle' : 'up-rectangle';

		// Store
		this.columnIndex = column;
		this.order = order;

		this.sort();
	},

	/**
	 * @method
	 * @param {object} opts Options
	 */
	sort(opts) {
		if (this.order == null || this.columnIndex == null) {
			return;
		}

		opts = opts || {};

		const data = this.data;
		const grid = this.grid;
		const behavior = grid.behavior;
		const order = this.order;

		// Just easier this way
		grid.clearSelections();
		grid.selectionChanged();

		// Sort the index
		const field = behavior.getColumn(this.columnIndex).properties.name;
		const self = this;
		let i, j;

		this.index.sort(function (a, b) {
			i = data[a][field];
			j = data[b][field];
			return order === 'desc'
				? self.descendingComparator(i, j)
				: self.ascendingComparator(i, j);
		});

		if (!opts.silent) {
			behavior.changed();
		}
		grid.repaint();
	},

	/**
	 * @method
	 * @param {event} event `fin-column-sort` event
	 */
	toggleSort(event) {
		const grid = this.grid;
		let x;

		if ((x = event != null ? event.detail.column : this.columnIndex) == null)
			return;

		// If it is the same column already being sorted on and we have already sorted to descending - reset
		if (this.columnIndex === x && this.order === 'asc') {
			// TODO: Their code does not take column headers into account as cells - even though this was in their example
			// this will cause the icon to be on the first cell just under the column cell
			// The only thing differntiating them in events is `isHeaderCell` the first row and the header row both claim to be y 0
			// grid.behavior.setCellProperty( x, 0, 'rightIcon', '');
			// grid.behavior.getColumn( this.columnIndex ).properties.backgroundColor = "white";
			this.unsort();
			grid.behavior.changed();
			grid.repaint();
		}
		// Either a new column sort or a new direction on the currently sorted column
		else {
			this.setSort(x, !this.order || this.columnIndex !== x ? 'desc' : 'asc');
		}
	},

	/**
	 * Destroy
	 * @method
	 * @param {Hypergrid} grid Grid
	 */
	uninstall(grid) {
		const dataModel = grid.behavior.dataModel;

		// Put data back
		this.unsort();

		// Clean up listeners
		grid.removeEventListener('fin-column-sort', this.toggleSort);
		grid.removeEventListener('fin-cell-exit', this.cellExit);
		grid.removeEventListener('fin-cell-enter', this.cellEnter);
		// Cannot trust this event
		// grid.removeEventListener('fin-canvas-mouseout', this.canvasMouseOut );
		grid.div.removeEventListener('mouseleave', this.onmouseleave);

		// Restore overriden methods
		dataModel.getValue = this.oldGetValue;
		dataModel.setValue = this.oldSaveValue;

		// Delete custom methods
		delete dataModel.getValueByField;
		delete dataModel.getRowIndex;
	},

	/**
	 * @method
	 * @param {object} opts Options
	 */
	unsort(opts) {
		opts = opts || {};

		const grid = this.grid;
		const behavior = grid.behavior;
		const index = this.index;
		let i, c;

		if (this.order != null && this.columnIndex != null) {
			// Just easier this way
			grid.clearSelections();
			grid.selectionChanged();

			// Unset icon
			behavior.getColumn(this.columnIndex).properties.columnRightIcon = '';

			this.columnIndex = null;
			this.order = null;
		}

		// Unsort the index
		for (i = 0, c = index.length; i < c; i++) {
			index[i] = i;
		}

		if (!opts.silent) {
			behavior.changed();
			grid.repaint();
		}
	},

	/**
	 * @method
	 */
	updateData() {
		const grid = this.grid;
		const dataModel = grid.behavior.dataModel;

		// Backup
		const columnIndex = this.columnIndex;
		const order = this.order;

		this.data = dataModel.dataSource.data;
		this.index = dataModel.sortIndex = new Array(this.data.length);

		// Unsort silently as we will be repainting once we re-apply the sort
		this.unsort({silent: true});

		// Reapply sort
		this.setSort(columnIndex, order);
	},
};

export default Sort;
